import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "./../index.css";

import _ from "lodash";
import moment from "moment";
import DOMPurify from "dompurify";
import Parser from 'html-react-parser';

import { Dialog } from "primereact/dialog";
import { ConfirmPopup } from "primereact/confirmpopup";

import Menu from "../../../helpers/Menu";
import { Button } from "../../../helpers";

import PIPunch from "./PIPunch";
import RevisePO from "./RevisePO";
import NewApprovalDisplay from "./NewApprovalDisplay";
import DownloadSellerPODialog from "./DownloadSellerPODialog";

import SendEmail from "../../../common/SendEmail";
import RemarksDialog from "../../../common/RemarksDialog";
import DocumentView from "../../../common/DocumentView";

import { cancelSellerPO } from "../../../services/api/sellerPO";
import { getDocCopyByDocNo } from "../../../services/api/docCopy";
import { getExpenseCategories } from "../../../services/api/expenseCategories";
import { updateApprovalInstances } from "../../../services/api/approvalInstances";
import { sendSellerPOMail } from "../../../services/api/sellerPO";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchApprovalSecondary, fetchApprovalTypes, fetchApprovals, fetchCompanyCreditPeriods, fetchIncoTerms, fetchMaterialBrands, fetchStates, fetchStatus, fetchTDSSections } from "../../../services/redux/reducers/commonThunk";

import { DATE_FORMAT } from "../../../constants";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";

import downloadFile from "../../../utils/DownloadFile";
import { getApprovalRequestStatusDetails, getApprovalStatus, getDateString, getPaymentTermsString, getProductName, getProductQty, getProductSpecification, getSellerPOApprovals, numberConversion, round } from "../../../utils";


const SellerPOView = (props) => {
    const {
        displayTable, 
        sellerPOId,
        sellerPO,
        sellerPOItems,
        sellerReqItems,
        sellerReqs,
        sellerPIPunch,
        sellerPIPunchItems,
        sellerReq,
        buyerQuoteItems,
        buyerPOItems,
        materialDetails,
        sellerCompanyDetails,
        pmCompanyBillAddrDetails,
        sellerBillAddrDetails,
        sellerShipAddrDetails,
        documentHTML,
        getSellerPO,
        setSellerPO,
        setDocumentHTML,
        sellerPOPdfURL,
        setSellerPOPdfURL,
        approvalInstances,
        setApprovalInstances,
        isLoading,
        setIsLoading,
        selectedReq,
        nonRoutedSellerPOsInfo,
        materialMandatoryUseFromStock,
        companyCertificates
    } = props

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const actionMenu = useRef(null)

    const [visiblePIPunch, setVisiblePIPunch] = useState(false)
    const [visibleRevisePO, setVisibleRevisePO] = useState(false)
    const [isPDFDownloading, setIsPDFDownloading] = useState(false)
    const [visibleApprovals, setVisibleApprovals] = useState(false)
    const [isEmailDialogVisible, setIsEmialDialogVisible] = useState(false)
    const [isReasonDialogVisible, setIsReasonDialogVisible] = useState(false)
    const [isDownloadDialogVisible, setIsDownloadDialogVisible] = useState(false)

    const [requiredApprovals, setRequiredApprovals] = useState([])
    const [expenseCategories, setExpenseCategories] = useState([])
    const [approvalRequestStatusDetails, setApprovalRequestStatusDetails] = useState([])

    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)
    const pmUserDetails = useSelector(state => state.userDetails.userNameDetails)
    const materialBrands = useSelector(state => state.common.materialBrands)
    const approvals = useSelector((state) => state.common.approvals)
    const approvalTypes = useSelector(state => state.common.approvalTypes)
    const approvalSecondary = useSelector((state) => state.common.approvalSecondary)
    const statusData = useSelector((state) => state.common.status)
    const incoTerms = useSelector((state) => state.common.incoTerms)
    const tdsSections = useSelector(state => state.common.tdsSections)

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale, currencyShortName} = pmCompanyConfig

    useEffect(() => {
        dispatch(fetchCompanyCreditPeriods())
        dispatch(fetchMaterialBrands())
        dispatch(fetchApprovals())
        dispatch(fetchApprovalTypes())
        dispatch(fetchApprovalSecondary())
        dispatch(fetchStatus())
        dispatch(fetchStates())
        dispatch(fetchIncoTerms())
        dispatch(fetchTDSSections())
        fetchExpenseCategories()
    }, [])


    let requiredApprovalTypeIds = sellerPO.expenseCategoryId ? pmCompanyConfig.expenseSellerPOApprovalTypeIds : pmCompanyConfig.sellerPOApprovalTypeIds
    let sellerPOApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => requiredApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals, sellerPO.sellerPOId])

    useEffect(() => {
        if (sellerPO.sellerPOId && sellerPOItems.length && materialDetails.length && sellerPOApprovals?.length && (buyerQuoteItems?.length || sellerPO?.expenseCategoryId) && materialBrands.length){
            calculateApprovalsNew()
        }
    }, [approvalInstances, sellerPO, sellerCompanyDetails, sellerPOItems, sellerPOApprovals, buyerQuoteItems, materialDetails, materialBrands])  

    const paymentTermsObj = getPaymentTermsString(sellerPO.paymentTerms, companyCreditPeriods)
    const maxLeadTimeSellerPOItem = _.max(sellerPOItems, "leadTime")
    let maxDeliveryTime = maxLeadTimeSellerPOItem?.leadTime
    
    const expectedDeliveryDate = moment(sellerPO?.createdAt).add(maxDeliveryTime, "days").format(DATE_FORMAT)

    let {
        notRequestedApprovalExists, 
        pendingApprovalsExist, 
        allApprovalsApproved
    } = getApprovalStatus(approvalRequestStatusDetails)

    if (sellerPIPunch.length || sellerPO.emailSent){
        pendingApprovalsExist = false
    }

    let emailDetailsObj = {}
    if (sellerBillAddrDetails?.companyName){
        emailDetailsObj = {
            to: sellerBillAddrDetails?.email,
            from: "orders@procmart.com",
            kam: pmUserDetails?.emailId,
            subject: `Purchase Order ${sellerBillAddrDetails.companyName} - ${moment(new Date()).format(DATE_FORMAT)} (${sellerPO?.docNo})`,
            message: `
                <div>
                    Dear Sir/Madam,

                    Greetings From ProcMart !!!!<br/><br/>
                    
                    This mail is with reference to <b>${sellerPO?.docNo}</b>.<br/>
                    Please find the attached purchase order for your kind perusal, kindly acknowledge the purchase order and revert back with the delivery timeline of the same.<br/>

                    Please note the following points -
                    <b>Delivery Period</b> : ${maxDeliveryTime} Days 
                    <b>Payment Terms</b> : ${paymentTermsObj?.paymentTermsString} <br/>

                    Also, find below billing and shipping details - <br/><br/>
                    <b>Billing Details</b>: <br/>
                    Instant Procurement Services Pvt. Ltd. <br/> 
                    ${pmCompanyBillAddrDetails.billAddress}, <br/>
                    ${pmCompanyBillAddrDetails.loc} - ${pmCompanyBillAddrDetails.pinCode} <br/>
                    ${pmCompanyBillAddrDetails.stateName}<br/>
                    ${pmCompanyConfig.GSTINLabel}: ${pmCompanyBillAddrDetails.gstinCode} <br/>
                    PAN: ${pmCompanyBillAddrDetails.panNum} <br/><br/>

                    <b>Shipping Details</b>: <br/> 
                    ${sellerShipAddrDetails.companyName}. <br/>
                    ${sellerShipAddrDetails.shipAddr}, <br/> 
                    ${sellerShipAddrDetails.city} -  ${sellerShipAddrDetails.pinCode} <br/>
                    STATE: ${sellerShipAddrDetails.stateName}<br/><br/>

                    Please process this order as per the attached document and above billing and shipping details. Also, share the proforma invoice for further proceedings.<br/><br/>
                    For any further clarifications, you can contact us at below-mentioned details, thanking you and assuring you of our best services at all times. <br/><br/>
                    ${pmUserDetails?.firstName} ${pmUserDetails?.lastName} <br/> ${pmUserDetails?.phoneNumber} <br/> ${pmUserDetails?.emailId}<br/><br/>

                    <h3>Please do not reply to this email, replies to this message are routed to an unmonitored mailbox.
                    If you have any questions please contact ${pmUserDetails?.firstName} ${pmUserDetails?.lastName} (${pmUserDetails?.emailId})</h3><br/>
                    <h3>Note: Invoices should be accepted as per our PO only.</h3>

                    <b>Expected Delivery Date</b>: ${expectedDeliveryDate}<br/>
                    In case of any delay in delivery, we will update you.<br/><br/>
                    
                    For any further clarifications, you can contact us at below-mentioned number, thanking you and assuring you of our best services at all times.
                </div>
            `,
            attachments: [{file_name: `PO_${sellerPO.docNo}_${sellerCompanyDetails.companyName}.pdf`, url: sellerPOPdfURL}]
        }
    }
    
    const actionMenuItems = [
        {
            label: 'View Doc',
            visible: displayTable ? true : false,
            command: () => {
                window.open(`/sellerpo/${sellerPO?.sellerPOId}`, "_blank")
            }
        },
        {
            label: 'PI Punch',
            command: () => {
                setVisiblePIPunch(true)
            },
            disabled: isPDFDownloading || (pendingApprovalsExist)
        },
        {
            label: 'Payment Summary',
            command: () => {
                navigate(`/vendor_payment_summary/${sellerPO.sellerPOId}`)
            },
            disabled: isPDFDownloading || (pendingApprovalsExist)
        },
        {
            label: isPDFDownloading ? "Loading..."  : 'Download Seller PO',
            permissions: [],
            command: () => handleDownloadSellerPO(),
            disabled: isPDFDownloading || (pendingApprovalsExist)
        },
        {
            label: sellerPO.emailSent ? 'Email Sent' : 'Send Email',
            command: () => setIsEmialDialogVisible(true),
            disabled: isPDFDownloading || pendingApprovalsExist || sellerPO?.statusId === 6 || sellerPO.emailSent,
            permissions: [196]
        },
        {
            label: "Regenerate Document",
            className: "",
            command: () => regenerateDocCopy(),            
            permissions: [102],
            visible: true,
            disabled: isLoading || isPDFDownloading
        },
        {
            label: 'Revise PO',
            permissions: [18],
            command: () => {
                setVisibleRevisePO(true)
            },
            disabled: sellerPO?.statusId === 6 || isPDFDownloading,
            className: "cancel-btn"  
        },
        {
            label: 'Cancel Seller PO',
            permissions: [18],
            command: () => {
                if (sellerPO?.statusId === 3){
                    setIsReasonDialogVisible(true)
                }
                else if(sellerPO?.statusId === 6){
                    dispatch(raiseToast({severity:'warn', detail:'Seller PO has been Cancelled Already.', life: 3000}))  
                }
            },
            disabled: sellerPO?.statusId === 6 || isPDFDownloading,
            className: "cancel-btn"
        }
    ]

    const fetchExpenseCategories = async () => {
		const response = await getExpenseCategories()
		if (response?.failure){
			dispatch(raiseToast({severity:'error', summary: 'Expense Categories', detail: response.data.error , life: 3000}))
		}

		const sortedExpenseCategories = _.sortBy(response.data, "expenseCategoryName")
		setExpenseCategories(sortedExpenseCategories)
	}

    const regenerateDocCopy = async () => {
        if(!window.confirm("Confirm to regenerate document")){
            return
        }

        setIsLoading(true)

        const createNewDocCopy = true
        const docCopyRes = await getDocCopyByDocNo(sellerPO.docNo, null, createNewDocCopy)

        if(docCopyRes.failure){
            dispatch(raiseToast({severity:'error', detail: docCopyRes.data.error, life: 3000}))
        }else{
            setSellerPOPdfURL(docCopyRes?.docLocation)
        }

        setIsLoading(false)
    }

    const calculateApprovalsNew = () => {
        let updatedSellerPO = {...sellerPO}

        let updatedRequiredApprovals = getSellerPOApprovals({
            POApprovals: sellerPOApprovals, 
            sellerPO: updatedSellerPO, 
            sellerPOItems: sellerPOItems, 
            sellerCompanyDetails: sellerCompanyDetails, 
            buyerQuoteItems: buyerQuoteItems, 
            companyCreditPeriods: companyCreditPeriods, 
            sellerPIPunch: sellerPIPunch,
            materialMasterData: materialDetails,
            buyerReq: selectedReq,
            buyerPOItems: buyerPOItems,
            nonRoutedSellerPOsInfo: nonRoutedSellerPOsInfo,
            sellerReqs: sellerReqs,
            sellerReqItems: sellerReqItems,
            materialMandatoryUseFromStock: materialMandatoryUseFromStock,
            materialBrands: materialBrands,
            companyCertificates: companyCertificates
        })
        setRequiredApprovals(updatedRequiredApprovals)

        const approvalIns = approvalInstances ? approvalInstances : []
        const approvalRequestStatusDetails = getApprovalRequestStatusDetails({
            updatedRequiredApprovals: updatedRequiredApprovals, 
            approvalInstances: approvalIns, 
            approvals: sellerPOApprovals, 
            pmBranchId: sellerPO?.pmBranchId, 
            sellerPO: updatedSellerPO
        })
        
        let updatedApprovalStatusDetails
        let prefillText = ""

        let totalSellerPOAmounts = 0
        let totalBuyerPOAmounts = 0

        if(!sellerPO.expenseCategoryId){
            sellerPOItems.map(eachSellerPOItem => {
                let relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                totalSellerPOAmounts += eachSellerPOItem.itemAmountBeforeTax
                totalBuyerPOAmounts += (eachSellerPOItem.qty * relatedBuyerPOItem.bPOUnitPrice)
            })
        }

        let marginPercentage = ((totalBuyerPOAmounts - totalSellerPOAmounts) / totalBuyerPOAmounts) * 100
        let relatedIncoTerm = incoTerms?.find(eachIncoTerm => eachIncoTerm?.incoTermId === sellerPO?.incoTermId)
       
        if (marginPercentage){
            prefillText += `Margin: ${round(marginPercentage)} %, `
        }
        if (sellerPO?.paymentTerms){
            let paymentTermsDisplay = ''
            Object.keys(sellerPO?.paymentTerms)?.map(eachTerm => {
                let relatedPaymentTermValue = sellerPO?.paymentTerms[eachTerm]
                if (eachTerm === "creditPeriodId"){
                    let relatedCompanyCreditPeriod = companyCreditPeriods?.find(eachCreditPeriod => eachCreditPeriod?.creditPeriodId === relatedPaymentTermValue)
                    if (relatedCompanyCreditPeriod && relatedCompanyCreditPeriod?.creditPeriod !== 0){
                        paymentTermsDisplay += `Credit: ${relatedCompanyCreditPeriod?.creditPeriodName}`
                    }
                }else{
                    if (relatedPaymentTermValue > 0){
                        paymentTermsDisplay += ` ${eachTerm}: ${relatedPaymentTermValue} `
                    }
                }
            })
            prefillText += `Payment Terms: ${paymentTermsDisplay}, `
        }
        if (sellerPO?.incoTermId && relatedIncoTerm){
            prefillText += `Inco Terms: ${relatedIncoTerm?.incoTerm} `
        }

        const isSellerPOLoss = totalBuyerPOAmounts < totalSellerPOAmounts
        let sellerPOLossPreFillText = ""
        if(isSellerPOLoss){
            if(marginPercentage){
                sellerPOLossPreFillText += `Loss: ${Math.abs(round(marginPercentage, 0))} %, `
            }
            if(totalBuyerPOAmounts){
                sellerPOLossPreFillText += `Loss Amount: ${numberConversion(totalSellerPOAmounts - totalBuyerPOAmounts)}, `
            }
            if(totalSellerPOAmounts){
                sellerPOLossPreFillText += `Seller PO Amount: ${numberConversion(totalSellerPOAmounts)}. `
            }
        }

        let sellerPOUnitPricePrefillText = ""
    
        if(!sellerPO.expenseCategoryId){
            sellerPOItems.map(eachSellerPOItem => {
                const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerReqItemId === eachSellerPOItem.buyerReqItemId && eachBuyerQuoteItem.statusId === 1 && eachBuyerQuoteItem.totReqQty > 0)
                let totalSellerQuotPrice = 0
                let validSellerQuoteCount = 0
                relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                    const relatedQuoteSellerReqItem = sellerReqItems.find(eachSellerReqItem => eachSellerReqItem.sellerReqItemId === eachBuyerQuoteItem.sellerReqItemId)
                    const relatedSellerReq = sellerReqs.find(eachSellerReq => eachSellerReq.sellerReqId === relatedQuoteSellerReqItem.sellerReqId)
                    if(![3625].includes(relatedSellerReq.companyId)){
                        totalSellerQuotPrice += eachBuyerQuoteItem.bQuotSellerQty * parseFloat(eachBuyerQuoteItem.bQuotSellerPrice)
                        validSellerQuoteCount += eachBuyerQuoteItem.bQuotSellerQty
                    }
                })
        
                const relatedSellerReqItem = sellerReqItems.find(eachSellerReqItem => eachSellerReqItem.sellerReqItemId === eachSellerPOItem.sellerReqItemId)
        
                let today = moment()
                const monthsSinceSellerRequestItemCreated = today.diff(relatedSellerReqItem.createdAt, 'months')
        
                let avgSellerQuotPrice = round(totalSellerQuotPrice / validSellerQuoteCount)
                const variationPercent = ((eachSellerPOItem.unitPrice - avgSellerQuotPrice) / avgSellerQuotPrice) * 100
        
                if ((variationPercent > 1 || monthsSinceSellerRequestItemCreated > 6) && sellerPO.companyId !== sellerPO.pmCompanyId){
                    sellerPOUnitPricePrefillText += `Material Id: ${eachSellerPOItem.materialId}, Seller Avg Price: ${avgSellerQuotPrice}, Seller Price Assigned: ${eachSellerPOItem.unitPrice} \n`
                }
            })
        }

        updatedApprovalStatusDetails = approvalRequestStatusDetails?.map(eachRequestDetail => {
            if (eachRequestDetail?.approvalTypeId === 17){
                return {...eachRequestDetail, remarks: prefillText, prefillText: prefillText}
            }
            if(eachRequestDetail.approvalTypeId === 33){
                return {...eachRequestDetail, remarks: sellerPOLossPreFillText, prefillText: sellerPOLossPreFillText}
            }
            if (eachRequestDetail.approvalTypeId === 16){
                return {...eachRequestDetail, remarks: sellerPOUnitPricePrefillText, prefillText: sellerPOUnitPricePrefillText}
            }
            return eachRequestDetail
        })
        console.log("updatedApprovalStatusDetails", updatedApprovalStatusDetails)
        setApprovalRequestStatusDetails(updatedApprovalStatusDetails)
    }

    const getSellerPOPDFURL = async () => {
        const generateIfNotExists = true
        const docCopyRes = await getDocCopyByDocNo(sellerPO.docNo, generateIfNotExists)

        if(docCopyRes.failure){
            setIsPDFDownloading(false)
            return dispatch(raiseToast({severity:'error', summary: "Seller PO Document", detail:docCopyRes.data.error, life: 3000}))
        }
        
        if(!docCopyRes?.docLocation){
            setIsPDFDownloading(false)
            return dispatch(raiseToast({severity:'error', summary: "Seller PO Document", detail: "Seller PO document was not found.", life: 3000}))
        }

        downloadFile(docCopyRes.docLocation, 'sellerPO.pdf')
        setIsPDFDownloading(false)

        getSellerPO()
    }

    const downloadSellerPO = () => {
        if (sellerPOPdfURL){
            downloadFile(sellerPOPdfURL, `PO_${sellerPO.docNo}_${sellerCompanyDetails.companyName}.pdf`)
        } else{
            setIsPDFDownloading(true)
            getSellerPOPDFURL()
        }
    }

    const handleCancelSellerPO = async (cancellationReason) => {
        if(cancellationReason){
            const activeSellerPIPunches = sellerPIPunch.filter(eachSellerPIPunch => eachSellerPIPunch.statusId === 1)

            if(activeSellerPIPunches.length > 0){
                if (window.confirm("Found Active Purchase invoices. Are you sure you want to partially cancel the seller po?")){
                    setIsLoading(true)
                    setIsReasonDialogVisible(false)
                    const response = await cancelSellerPO(sellerPOId, {cancellationReason, allowPartialConfirmation: true})
                    if (response.failure){
                        setIsLoading(false)
                        return dispatch(raiseToast({severity:'error', detail: response.data.error}))
                    } else {
                        getSellerPO()
                        setIsLoading(false)
                        dispatch(raiseToast({severity:'warn', detail:'Seller PO has been Marked as Cancelled.'})) 
                        setIsReasonDialogVisible(false)
                    }
                }
            } else {
                if (window.confirm("Are you sure you want to cancel the seller po?")){
                    setIsLoading(true)
                    setIsReasonDialogVisible(false)
                    const response = await cancelSellerPO(sellerPOId, {cancellationReason})

                    if (response?.failure){
                        setIsLoading(false)
                        return dispatch(raiseToast({severity:'error', detail: response.data.error}))
                    } else {
                        if(response.data.updatedSellerPO.statusId === 6 && approvalInstances.length > 0){

                            let pendingApprovalInstances = approvalInstances.filter(eachIns => [12].includes(eachIns.statusId))

                            const updatedApprovalInstances = pendingApprovalInstances.map(eachIns => {
                                return {
                                    ...eachIns,
                                    statusId: 2
                                }
                            })

                            const approvalInstacesRes = await updateApprovalInstances(updatedApprovalInstances)
                            if (approvalInstacesRes.failure) {
                                setIsLoading(false)
                                return dispatch(raiseToast({ severity: 'error', summary: 'Approval Requests', detail: approvalInstacesRes.data.error, life: 3000 }))
                            }else{
                                setApprovalInstances(approvalInstacesRes.data)
                            }
                        }

                        getSellerPO()
                        setIsLoading(false)
                        dispatch(raiseToast({severity:'warn', detail:'Seller PO has been Marked as Cancelled.'})) 
                        setIsReasonDialogVisible(false)
                    } 
                }
            }
        }
    }

    const handleSendSellerPOMail = async (emailObj) => {
        setIsLoading(true)
        const updatedEmailObj = {...emailObj, cc: [...emailObj.cc, pmUserDetails.emailId], useOrders: true}
        const sendSellerPOMailRes = await sendSellerPOMail(sellerPO.sellerPOId, updatedEmailObj)
        if (sendSellerPOMailRes.failure){
            dispatch(raiseToast({severity:'error', summary: "Send Seller PO Mail", detail: sendSellerPOMailRes.data.error, life: 3000}))
        }else{
            dispatch(raiseToast({severity:'success', detail: "Mail has been sent succesfully", life: 3000}))
        }
        setSellerPO({...sellerPO, emailSent: true})
        setIsLoading(false)
    }

    const handleApprovalRequest = (data) => {
        setApprovalInstances([...approvalInstances, data])
    }

    const handleRemarks = (srNo, text, prefillText) => {
        const updatedApprovalRequestStatusDetails = approvalRequestStatusDetails.map(eachRequestDetail => {
            if(eachRequestDetail.srNo === srNo){
                if([17, 33, 9, 16].includes(eachRequestDetail.approvalTypeId)){
                    if (text.startsWith(prefillText)) {
                        return {...eachRequestDetail, remarks: text}
                    } else {
                        return {...eachRequestDetail, remarks: prefillText}
                    }
                } else {
                    return {...eachRequestDetail, remarks: text}
                }
            }
            return eachRequestDetail
        })

        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const handleCopyClick = (docNo) => {
        if(docNo){
            navigator.clipboard.writeText(docNo)
            .then(() => {
                return dispatch(raiseToast({severity:'success', summary: 'Seller Purchase Order', detail: "Successfully copied", life: 3000}))
            })
            .catch((error) => {
                return dispatch(raiseToast({severity:'error', summary: 'Seller Purchase Order', detail: "Can't copy", life: 3000}))
            })
        }
    }

    const handleDownloadSellerPO = () => {
        if (sellerPO.emailSent){
            downloadSellerPO()
        } else{
            setIsDownloadDialogVisible(true)
        }
    }

    const renderHTMLSellerPODocument = (documentHTML) => {
        const sanitizedHTML = DOMPurify.sanitize(documentHTML)
        return(
            <>
                {Parser(sanitizedHTML)}
            </>
        )
    }

    const renderSellerPOPDF = (sellerPOPdfURL) => {
        return(
            <div className="document-y-scroll">
                <div style={{ width: '210mm', minHeight: '297mm' }}>
                    {
                        sellerPOPdfURL ?
                            <DocumentView fileUrl={sellerPOPdfURL} />
                            :
                            <p className="">Document not found!</p>
                    }
                </div>
            </div>

        )
    }

    const renderTableStructure = () => {

        return (
            <div className={`p-card my-2 py-2 sellerpo-modal-data ${sellerPO?.statusId === 6 ? 'cancelled-watermark' : ''}`}>
                <ConfirmPopup />
                <div className="grid">
                    <div className="flex flex-row col-12 justify-content-between pb-0 pt-0">
                        <div className="flex flex-row justify-content-start align-items-center col-12 md:col-4 lg:col-3 lg:mb-0 pl-0">
                            <h5 className="quote-number doc-no-navigation m-0" onClick={() => window.open(`/sellerpo/${sellerPO?.sellerPOId}`)}> <span style={{ fontWeight: "lighter" }}>Seller PO No:</span> {sellerPO?.docNo}</h5>
                            {
                                sellerPO?.docNo ? <i className='pi pi-copy pl-2 doc-copy-icon' onClick={() => handleCopyClick(sellerPO?.docNo)} ></i> : ""
                            }  
                        </div>
                        <div className="flex flex-row lg:mb-0 align-items-center">
                            <div><span>Seller Company:</span>&nbsp;<span className="price-value">{sellerCompanyDetails.companyName}</span></div> &nbsp; &nbsp;
                            <div><span>created on:</span>&nbsp;<span className="price-value">{createdAtString}</span></div>
                        </div>

                        <div className="flex flex-row col-12 mb-2  md:col-4 lg:col-2 lg:mb-0 align-items-center justify-content-end">
                            <Button className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${approvalIconColour}`} rounded onClick={() => setVisibleApprovals(true)} disabled={isLoading || !approvalRequestStatusDetails.length} >
                                <i className={isLoading ? "pi pi-spin pi-spinner" : approvalsIcon} style={{ fontSize: "0.9rem", cursor: "pointer" }} />
                            </Button>
                            <div className="flex gap-2 justify-content-end">
                                <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                                <Button className="ml-2" rounded onClick={(e) => actionMenu.current.toggle(e)} disabled={isLoading} style={{backgroundColor: !sellerPO.emailSent ? "orange" : ""}} >
                                    <i className={isLoading ? "pi pi-spin pi-spinner" : "pi pi-ellipsis-h"} style={{ fontSize: "0.9rem", cursor: "pointer" }} />
                                </Button>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="custom-table-container">
                    <table className="custom-product-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="">
                                <th className="" >SR</th>
                                <th className="">MATERIAL ID</th>
                                <th className="" style={{ width: "20%" }}>PRODUCT</th>
                                <th className="" style={{ width: "25%" }}>SPECIFICATION</th>
                                <th className="" >BRAND</th>
                                <th className="" >LEAD TIME</th>
                                <th className="" >QUANTITY</th>
                                <th className="" >UNITPRICE</th>
                                <th className="" >GSTRATE</th>
                                <th className="" >AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                sellerPOItems.length && materialDetails.length ? 
                                (
                                    sellerPOItems?.map((eachSellerPOItem, index) => {
                                        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachSellerPOItem?.materialId)
                                        const relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === relatedMaterial?.brandId)
                                        return (
                                            <tr key={`sellerPOItem-${eachSellerPOItem.sellerPOItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                <td className="">{index + 1}</td>
                                                <td className="">{relatedMaterial?.materialId}</td>
                                                <td className="">{getProductName(relatedBrand?.brandName, relatedMaterial?.productName, relatedMaterial?.variantName)}</td>
                                                <td className="">{getProductSpecification(relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</td>
                                                <td className="">{relatedBrand?.brandName}</td>
                                                <td className="">{eachSellerPOItem.leadTime} Day(s)</td>
                                                <td className="">{getProductQty(eachSellerPOItem.qty, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</td>
                                                <td className="">{currencyShortName}.{numberConversion(eachSellerPOItem?.unitPrice, numberLocale)}</td>
                                                <td className="">{eachSellerPOItem?.GSTRate}%</td>
                                                <td className="">{numberConversion(eachSellerPOItem?.itemAmountWithTax, numberLocale)}</td>
                                            </tr>
                                        )
                                    })
                                )
                                :
                                null
                            }
                        </tbody>
                    </table>
                    <div className="flex flex-column col-12 m-0 p-0 align-items-end justify-content-center mt-2">
                        <div><span>Total Amount:</span>&nbsp;&nbsp;<span className="price-value">{(numberConversion(parseFloat(sellerPO?.totalItemAmountWithTax), numberLocale))}</span></div>
                    </div>
                </div>
            </div>
        )
    }

    const renderDocumentStructure = () => {
        return (
            <>
                <div className="mb-0 document-page-container">
                    <div className="flex flex-column md:flex-row md:justify-content-between">
                        <h4 className="mt-2 mb-0">SELLER PO <span style={{fontWeight: "normal"}}>{relatedExpenseCategory ? ` | Expense - ${relatedExpenseCategory}` : ""}</span></h4>
                        <div className="flex justify-content-end mb-2">
                            <Button className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${pendingApprovalsExist && "red-text"} ${allApprovalsApproved && "green-text"}`} label="Approvals" onClick={() => setVisibleApprovals(true)} disabled={!approvalRequestStatusDetails.length} />
                            <div className="flex gap-2 justify-content-end ml-2">
                                <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                                <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} disabled={isLoading} />
                            </div>
                        </div>
                    </div>
                </div>
                
            </>
        )
    }

    let relatedExpenseCategory = ""
    expenseCategories.map(eachExpenseCategory => {
        if(eachExpenseCategory.expenseCategoryId === sellerPO.expenseCategoryId){
            relatedExpenseCategory = eachExpenseCategory.expenseCategoryName
        }
    })

    let createdAtString = getDateString(sellerPO?.createdAt)

    let approvalsIcon = 'pi pi-check'
    let approvalIconColour = "green-text"

    if (pendingApprovalsExist){
        approvalsIcon = "pi pi-hourglass"
        approvalIconColour = "yellow-text"
    }
    if (notRequestedApprovalExists){
        approvalsIcon = 'pi pi-times'
        approvalIconColour = "red-text"
    }
    if (allApprovalsApproved){
        approvalsIcon = "pi pi-check"
        approvalIconColour = "green-text"
    }

    return (
        <>
            {
                displayTable ? 
                renderTableStructure()
                :
                renderDocumentStructure()
            }
            <RemarksDialog visible={isReasonDialogVisible} onHide={() => setIsReasonDialogVisible(current => !current)} onSubmit={handleCancelSellerPO}/>
            <SendEmail emailDetailsObj={emailDetailsObj} handleSendMail={handleSendSellerPOMail} visible={isEmailDialogVisible} onHide={() => setIsEmialDialogVisible(current => !current)}/>

            <Dialog header="Approvals" className="approvals-dialog" visible={visibleApprovals} onHide={() => setVisibleApprovals(false)} style={{ width: '80vw', height: '80vh' }} >
                <NewApprovalDisplay
                    sellerPO={sellerPO}
                    sellerReq={sellerReq}
                    requiredApprovals={requiredApprovals}
                    approvalTypes={approvalTypes}
                    approvalInstances={approvalInstances}
                    approvalSecondary={approvalSecondary}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    sellerPOApprovals={sellerPOApprovals}
                    statusData={statusData}
                    isDoc={true}
                    sellerCompanyDetails={sellerCompanyDetails}
                    handleApprovalRequest={handleApprovalRequest}
                    companyCreditPeriods={companyCreditPeriods}
                    handleRemarks={handleRemarks}
                    buyerQuoteItems={buyerQuoteItems}
                    sellerPOItems={sellerPOItems}
                    materialDetails={materialDetails}
                    buyerPOItems={buyerPOItems}
                    incoTerms={incoTerms}
                    tdsSections={tdsSections}
                    materialMandatoryUseFromStock={materialMandatoryUseFromStock}
                    materialBrands={materialBrands}
                    companyCertificates={companyCertificates}
                />
            </Dialog>
            
            <Dialog header="PI Punch" className="pi-punch-dialog" visible={visiblePIPunch} style={{ width: '90vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setVisiblePIPunch(false)} >
                <PIPunch 
                    sellerPOId={sellerPOId}
                    sellerBillAddrDetails={sellerBillAddrDetails}
                    setSellerPOPdfURL={setSellerPOPdfURL}
                    setDocumentHTML={setDocumentHTML}
                />
            </Dialog>

            <Dialog header={"REVISE PO"} className="pi-punch-dialog" visible={visibleRevisePO} style={{ width: '70vw', height: '65vh', backgroundColor: '#f8f8f8' }} onHide={() => setVisibleRevisePO(false)} >  
                <RevisePO 
                    sellerPO={sellerPO} 
                    sellerPOItems={sellerPOItems} 
                    sellerPIPunch={sellerPIPunch} 
                    sellerPIPunchItems={sellerPIPunchItems} 
                    materialDetails={materialDetails} 
                    materialBrands={materialBrands} 
                    setIsLoading={setIsLoading}
                    getSellerPO={getSellerPO}
                />
            </Dialog>
            <Dialog header={"Download Seller PO"} className="" visible={isDownloadDialogVisible} style={{ width: '20vw', height: '20vh' }} onHide={() => setIsDownloadDialogVisible(false)} >
                <DownloadSellerPODialog
                    sellerPO={sellerPO}
                    setSellerPO={setSellerPO}
                    downloadSellerPO={downloadSellerPO}
                    setIsDownloadDialogVisible={setIsDownloadDialogVisible}
                />
            </Dialog>
            {!isLoading && !displayTable ?
                (sellerPOPdfURL ? renderSellerPOPDF(sellerPOPdfURL) : <div className={sellerPO?.statusId === 6 && "cancelled-watermark"}>{renderHTMLSellerPODocument(documentHTML)}</div>
                ) : null}
        </>
    )
}

export default SellerPOView;